<script>
import {defineComponent} from 'vue'
import {ElNotification} from "element-plus";
import moment from "moment";

export default defineComponent({
  name: "StateFundForm",
  data() {
    return {
      loading: false,
      form: {
        fund_id: null,
        year: moment(Date.now()).format("YYYY"),
        quarter: null,
        transfers: null,
        revenue: null,
        expenditure: null
      },
      funds: [],
      quarters: [
        {value: 1},
        {value: 2},
        {value: 3},
        {value: 4}
      ],
      rules: {
        fund_id: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        year: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        quarter: [{required: true, message: "Majburiy maydon", trigger: "change"}],
        transfers: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        revenue: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
        expenditure: [{required: true, message: "Majburiy maydon", trigger: "blur"}],
      }
    }
  },
  methods: {
    getFundList() {
      this.loading = true;
      this.$http.get(`api/v1/funds`, {
        params: {
          limit: 10000,
          offset: 0
        }
      }).then(({data}) => {
        this.funds = data.data;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
    getFundById() {
      this.loading = true;
      this.$http
          .get(`/api/v1/state-target-funds/${this.form.id}`)
          .then(({data}) => {
            this.form = data;
            this.form.year = data.year.toString()
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.year = Number(this.form.year)
          let http;
          if (this.form.id) {
            http = this.$http.put(`/api/v1/state-target-funds/${this.form.id}`, this.form);
          } else {
            http = this.$http.post("/api/v1/state-target-funds", this.form);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      })
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.form.id = this.$route.params.id;
      this.getFundById()
    }
    this.getFundList()
  }
})
</script>

<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Jamg'armani tanlang" prop="fund_id">
                <el-select class="form-input" v-model="form.fund_id" size="large"
                           style="margin-right: 10px;width: 100%"
                           placeholder="Jamg'armani tanlang">
                  <el-option v-for="item in funds"
                             :value="item.id"
                             :label="item.title"
                             :key="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Yilni tanlang" prop="year">
                <el-date-picker
                    size="large"
                    style="width: 100%"
                    v-model="form.year"
                    type="year"
                    format="YYYY"
                    value-format="YYYY"
                    placeholder="Yilni tanlang"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Chorakni tanlang" prop="quarter">
                <el-select class="form-input" v-model="form.quarter" size="large"
                           style="margin-right: 10px;width: 100%"
                           placeholder="Chorakni tanlang">
                  <el-option v-for="item in quarters"
                             :value="item.value"
                             :label="item.value"
                             :key="item.value"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Transfer" prop="transfers">
                <el-input size="large" v-model.number="form.transfers" type="number"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Daromad" prop="revenue">
                <el-input size="large" v-model.number="form.revenue" type="number"/>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="12">
              <el-form-item label="Xarajat" prop="expenditure">
                <el-input size="large" v-model.number="form.expenditure" type="number"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button size="large" class="custom-btn" @click="() => this.$router.go(-1)"
                >Orqaga
                </el-button
                >
                <el-button size="large" class="custom-btn" type="primary" @click="onSubmit"
                >Saqlash
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>

</style>
